import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

type TSubmenu = {
  label: string;
  path: string;
  hidden?: boolean;
};

type TMenu = {
  label: string;
  path: string;
  icon: string;
  children: TSubmenu[];
};

@Component({
  selector: 'app-accordion',
  imports: [NgClass, RouterLink, RouterLinkActive],
  templateUrl: './accordion.html',
  styleUrl: './accordion.scss',
})
export class Accordion {
  @Input() menu!: TMenu;
  @Input() isCollapsed: boolean = false;

  sectionOpen = false;

  toggleSection(): void {
    this.sectionOpen = !this.sectionOpen;
  }
}
